window.attachMedium = {
  initAttachScan() {
    ///// 以下のid/classを各要素に記述してください /////
    // 添付ファイルを指定する input[type="file"] 要素
    const inputFile = document.querySelector("#medium_file");
    // 添付ファイルのプレビュー用 img 要素
    const imgPreview = document.querySelector("#file_preview");
    // 添付ファイルのプレビューを拡大するための a 要素
    const aEnlarge = document.querySelector("#file_enlarge");
    // 表示用テキスト(medium.name)を指定する input[type="text"] 要素
    const inputName = document.querySelector("#medium_name");
    // 添付ファイルのファイル名を指定する input[type="text"] 要素
    const inputFilename = document.querySelector("#medium_filename");
    // 保存・更新ボタン(上下2つなのでclass指定)
    const buttonsSave = document.querySelectorAll(".save");
    // ファイル名確認ボタン
    const buttonCheck = document.querySelector("#check-duplication");
    // ファイル名入力欄のファイル名で登録可能な場合の通知欄の div 要素
    const divValidFilename = document.querySelector("#valid-filename");
    // ファイル名入力欄が空の場合の通知欄の div 要素
    const divNoticeEmpty = document.querySelector("#notice-empty");
    // ファイル名が重複していた場合の通知欄の div 要素
    const divNoticeDuplication = document.querySelector("#notice-duplication");
    // その通知欄の中の、受付可能なファイル名を表示する span 要素
    const spanAlternates = document.querySelector("#filename-alternates");

    /////

    let resultJson = {};

    inputFile.addEventListener("change", () => {
      const file = inputFile.files[0];

      if (file) {
        if (!inputName.value)
          inputName.value = (file.name || "").replace(/\.[^.]+$/, "");
        if (!inputFilename.dataset.originalName) {
          // data-original-name 属性がなければ、新規の登録の場合なのでファイル名欄を添付されたファイルの名前に変更します
          inputFilename.value = file.name;
        }
        checkDuplication();

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.addEventListener(
          "load",
          function () {
            imgPreview.src = reader.result;
            aEnlarge.href = reader.result;
          },
          false,
        );
      }
    });

    inputFilename.addEventListener("input", () => {
      // ファイル名の重複が未確認になったのでフラグは変えます
      // ただし、 resultJson.alternates が設定済みの場合は、その情報は有用なので残します
      resultJson.unique = false;
      updateView();
    });
    buttonCheck.addEventListener("click", checkDuplication);

    checkDuplication();

    function updateView() {
      const isEmpty = inputFilename.value == "";
      const inputFilenameIsOriginalName =
        !isEmpty && inputFilename.value == inputFilename.dataset.originalName;
      const isUnique = inputFilenameIsOriginalName || resultJson.unique;

      buttonsSave.forEach((button) => (button.disabled = !isUnique));
      buttonCheck.disabled = isUnique;

      divValidFilename.style.display = isUnique ? "" : "none";
      divNoticeEmpty.style.display = isEmpty ? "" : "none";
      divNoticeDuplication.style.display =
        !isEmpty && resultJson.alternate ? "" : "none";
      spanAlternates.textContent = resultJson.alternate;

      return isUnique;
    }

    async function checkDuplication() {
      if (updateView()) {
        return;
      }

      if (inputFilename.value == "") {
        return;
      }

      const response = await fetch(
        `/v2/media/check_duplication?filename=${inputFilename.value}`,
      );
      resultJson = await response.json();
      updateView();
    }
  },
};
